module.exports = __webpack_public_path__ + "static/media/promotion_cn.281ad908.png";